import { useMemo } from 'react'
import { useIntl } from 'react-intl'

function useInsuranceLabels() {
  const intl = useIntl()

  return useMemo(() => {
    const protectedFlightsName = intl.formatMessage({
      id: 'nwb-FnHMVJVoiL2BF-Jd',
      defaultMessage: 'Luxury Escapes Protect',
      description: 'Display name for the Luxury Escapes Protect insurance product',
    })

    const cancellationReasons: Array<string> = [
      intl.formatMessage({
        id: 'JkLze2sx6DFkJzMR-mpb',
        defaultMessage: 'Illness/injury (including Covid)',
        description: 'Insurance cancellation reason for illness or injury including Covid',
      }),
      intl.formatMessage({
        id: 'cKrkvyquBwfUPmAbh7gQ',
        defaultMessage: 'Pre-existing medical condition',
        description: 'Insurance cancellation reason for pre-existing medical condition',
      }),
      intl.formatMessage({
        id: 'e1MLmlP9yay1mkJRzYvN',
        defaultMessage: 'Court summons',
        description: 'Insurance cancellation reason option for court summons attendance',
      }),
      intl.formatMessage({
        id: 'Zgq_RncQrEcAjUW8UwLQ',
        defaultMessage: 'Workplace redundancy',
        description: 'Insurance cancellation reason for workplace redundancy',
      }),
      intl.formatMessage({
        id: 'ujoO1PMaUmqKVqNVGgst',
        defaultMessage: 'Death of immediate family',
        description: 'Insurance cancellation reason for death of immediate family member',
      }),
      intl.formatMessage({
        id: 'zRvJ_gksrmHVKl2t78yP',
        defaultMessage: 'Public transport failure',
        description: 'Insurance cancellation reason for public transport failure',
      }),
      intl.formatMessage({
        id: 'SZP60RK0TgqX2MJeioH0',
        defaultMessage: 'Relocated for work',
        description: 'Insurance cancellation reason option for being relocated for work',
      }),
      intl.formatMessage({
        id: 'hQ4yVYrc7QIrJ8NRGVnP',
        defaultMessage: 'Armed forces & emergency services recall',
        description: 'Insurance cancellation reason for armed forces or emergency services recall',
      }),
      intl.formatMessage({
        id: '4L85RFfyBRHq8VSX6Xu3',
        defaultMessage: 'Home emergency',
        description: 'Insurance cancellation reason option for a home emergency event',
      }),
      intl.formatMessage({
        id: 'CKcOTSkU3AEo9J2rDQM4',
        defaultMessage: 'Theft of documents',
        description: 'Insurance cancellation reason for theft of documents',
      }),
      intl.formatMessage({
        id: 'jXWpYe_OtWtyQIRMsQ58',
        defaultMessage: 'Pregnancy complication',
        description: 'Insurance cancellation reason for pregnancy complication',
      }),
      intl.formatMessage({
        id: 'ltc_0Ttjdpuu7EAlc6wq',
        defaultMessage: 'Jury service',
        description: 'Insurance cancellation reason for jury service or jury duty',
      }),
      intl.formatMessage({
        id: '0KTVF6cBdMB4-pkFXlX8',
        defaultMessage: 'Flight disruption',
        description: 'Insurance cancellation reason for flight disruption or delay',
      }),
      intl.formatMessage({
        id: '7-WZkPrmS-tm3xWJ3be2',
        defaultMessage: 'Mechanical breakdown',
        description: 'Insurance cancellation reason for mechanical breakdown of vehicle',
      }),
      intl.formatMessage({
        id: '-hsVj7u5usJCbCsnM5LW',
        defaultMessage: 'Adverse weather',
        description: 'Insurance cancellation reason for adverse weather conditions',
      }),
      intl.formatMessage({
        id: 'OZyKPn9uubh9KlDZjw4e',
        defaultMessage: 'Changes to examination dates',
        description: 'Insurance cancellation reason for changes to examination dates',
      }),
    ]

    return {
      protectedFlightsName,
      cancellationReasons,
    }
  }, [intl])
}

export default useInsuranceLabels
